export const projects = [
    {
        id: 0,
        name: 'Credit Card Tracker',
        img: require('./creditCardTracker/img/ccTracker.png'),
        url: '/credit-card-tracker',
        duration: 'June 2026 - Present [WIP]',
        description: "A credit card & benefit management tool that automates reminders and benefit tracking to eliminate manual check-ins."
    },
    {
        id: 1,
        name: 'Kingpin',
        img: require('./kingpin/img/kingpin1.png'),
        url: '/kingpin',
        duration: '2022, 2025 - Present [WIP]',
        description: "A collaborative storyscape site dedicated to fantasy world-building, character design, and story writing."
    },
    {
        id: 2,
        name: 'Cisco AppD Internship',
        url: '/cisco-intern',
        img: require('./internship/img/internship.svg').default,
        duration: 'June 2022 - March 2023',
        description: "A look into various design and frontend dev projects over the course of my internship at Cisco AppDynamics."
    },
    {
        id: 3,
        name: 'An Improved HEM',
        url: '/hem',
        img: require('./hem/img/hem.svg').default,
        duration: 'January 2022 - March 2022',
        description: "A redesign of UC Davis' Health-E-Messaging desktop UI for scheduling COVID-19 testing appointments."
    },
    {
        id: 4,
        name: 'Compared to What?',
        url: '/compared-to-what',
        img: require('./comparedToWhat/img/c2w.svg').default,
        duration: 'May 2021 - June 2021',
        description: "A mobile web page designed to inform viewers of the rise in UC tuition compared to notable statistics."
    },
]